import { Icon123 } from "@tabler/icons-react";
//import { PlusCircleIcon, PlusIcon } from "@heroicons/react/24/outline";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

const AppNumberFieldIcon = (props: Props) => {
  const { className, ...rest } = props;

  return <Icon123 {...rest} className={props.className} />;
};
export default withIconSize(AppNumberFieldIcon);
